import BaseView from "../../../js/base-view";

export default class MediaHeader extends BaseView {}
